import { useMemo } from "react";
import { useLocation } from "react-router-dom";

function mapValue(value) {
  if (value === "true" || value === "false" || value === "null") {
    return JSON.parse(value);
  }
  if (value === "undefined") {
    return undefined;
  }
  return value;
}

export function useSearchParams(queryStr) {
  const location = useLocation();
  const searchParams = useMemo(() => {
    const params = new URLSearchParams(queryStr || location.search);
    const result = {};
    for (const [key] of params) {
      const allValues = params.getAll(key).map(mapValue);
      result[key] = allValues.length <= 1 ? allValues[0] : allValues;
    }
    return result;
  }, [location.search, queryStr]);

  return searchParams;
}
